import mapPdf from "./resources/uptown-porchfest-map-2026.pdf";

const Map = () => {
  return (
    <div>
      <div className="for-bands-banner">
        <h2>
          For our more analog friends we have a PDF map and schedule {" "}
          <a href={mapPdf} target="_blank" rel="noreferrer">
            here!
          </a>
        </h2>
      </div>
      <div style={{ height: "85vh" }}>
        <iframe
          title="porchfest_map"
          src="/map.html"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allow="geolocation"
        ></iframe>
      </div>
    </div>
  );
};

export default Map;
